import { useState } from "react";
import { MAINTENANCE_NOTICE, maintenanceNoticeActive } from "../../config/maintenance";
import "./MaintenanceNotice.css";

const DISMISS_KEY = "hr_maintenance_notice_dismissed";

// A quiet, dismissible notice about scheduled maintenance. Bottom left, so
// it never sits on the Soko button (bottom right) and never shifts layout.
// Dismissal lasts for the browser session only: a visitor who closes it and
// returns the next day sees it again.
export default function MaintenanceNotice({ now }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === MAINTENANCE_NOTICE?.showFrom; } catch { return false; }
  });
  if (dismissed || !maintenanceNoticeActive(now || new Date())) return null;
  const close = () => {
    setDismissed(true);
    try { sessionStorage.setItem(DISMISS_KEY, MAINTENANCE_NOTICE.showFrom); } catch { /* storage blocked: it just reappears next page */ }
  };
  return (
    <div className="maint-notice" role="status" data-testid="maintenance-notice">
      <p className="maint-notice-text">{MAINTENANCE_NOTICE.text}</p>
      <button type="button" className="maint-notice-close" onClick={close} aria-label="Dismiss the maintenance notice">×</button>
    </div>
  );
}
